/* ==========================================================================
   BGalz theme — plain JS, no framework, no jQuery.
   ========================================================================== */
(function () {
  'use strict';

  var BG = window.BG || {};
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };

  /* ---------- money ----------------------------------------------------- */
  // Shopify gives cents everywhere in the Cart/Product JSON APIs, but
  // /search/suggest.json returns dollar strings ("52.99"). Two entry points,
  // one formatter, so the two never get confused again.
  function fmt(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var n = parts.join('.');
    var f = BG.money_format || '${{amount}}';
    if (f.indexOf('{{') === -1) return '$' + n;
    return f.replace(/\{\{\s*\w+\s*\}\}/, n);
  }
  function money(cents) { return fmt(cents); }
  function moneyFromDollars(s) {
    var n = parseFloat(String(s).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? '' : fmt(Math.round(n * 100));
  }

  /* ---------- toast ----------------------------------------------------- */
  var toastEl = $('[data-toast]'), toastT;
  function toast(msg, bad) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.toggle('bad', !!bad);
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2800);
  }

  /* ---------- scroll lock ----------------------------------------------- */
  var lockCount = 0, lockY = 0;
  function lock() {
    if (lockCount++ > 0) return;
    lockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -lockY + 'px';
    document.body.style.width = '100%';
  }
  function unlock() {
    if (--lockCount > 0) return;
    lockCount = 0;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockY);
  }

  /* ======================================================================
     Header: sticky + measured height
     ====================================================================== */
  (function () {
    var hdr = $('[data-sticky-header]');
    if (!hdr) return;
    var ph = document.createElement('div');
    hdr.parentNode.insertBefore(ph, hdr);
    var h = 0, stuck = false;

    function measure() {
      h = hdr.offsetHeight;
      document.documentElement.style.setProperty('--hdr-h', h + 'px');
      if (stuck) ph.style.height = h + 'px';
    }
    function onScroll() {
      var top = ph.getBoundingClientRect().top;
      if (!stuck && top < 0) {
        stuck = true;
        ph.style.height = h + 'px';
        hdr.classList.add('is-stuck');
        hdr.style.position = 'fixed';
        hdr.style.top = '0';
        hdr.style.left = '0';
        hdr.style.right = '0';
        hdr.style.zIndex = '90';
        hdr.style.boxShadow = '0 3px 16px rgba(16,16,20,.10)';
      } else if (stuck && top >= 0) {
        stuck = false;
        ph.style.height = '0px';
        hdr.classList.remove('is-stuck');
        hdr.style.position = '';
        hdr.style.top = '';
        hdr.style.left = '';
        hdr.style.right = '';
        hdr.style.zIndex = '';
        hdr.style.boxShadow = '';
      }
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ======================================================================
     Dropdowns / mega menu
     Hover opens, click pins. The bug worth remembering: mousedown also fires
     focus, and a focus handler that re-opens + resets the hover flag makes a
     click straight after a hover close and immediately reopen. So always read
     the current open state before touching the flag.
     ====================================================================== */
  (function () {
    var groups = $$('[data-dd]');
    if (!groups.length) return;
    var openOne = null;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    function panelOf(g) { return $('[data-dd-panel]', g); }
    function btnOf(g)   { return $('[data-dd-btn]', g); }

    function show(g) {
      if (openOne && openOne !== g) hide(openOne);
      var p = panelOf(g), b = btnOf(g);
      if (!p) return;
      p.classList.add('on');
      if (b) b.setAttribute('aria-expanded', 'true');
      openOne = g;
    }
    function hide(g) {
      var p = panelOf(g), b = btnOf(g);
      if (!p) return;
      p.classList.remove('on');
      if (b) b.setAttribute('aria-expanded', 'false');
      g.__pinned = false;
      if (openOne === g) openOne = null;
    }

    groups.forEach(function (g) {
      var b = btnOf(g), p = panelOf(g), t;
      if (!p) return;
      g.__pinned = false;

      if (canHover) {
        on(g, 'mouseenter', function () { clearTimeout(t); if (!g.__pinned) show(g); });
        on(g, 'mouseleave', function () {
          if (g.__pinned) return;
          t = setTimeout(function () { if (!g.__pinned) hide(g); }, 140);
        });
      }

      on(b, 'click', function (e) {
        e.preventDefault();
        if (g.__pinned) { hide(g); return; }
        show(g);
        g.__pinned = true;   // a hover-opened panel stays open on first click
      });

      on(g, 'keydown', function (e) { if (e.key === 'Escape') { hide(g); if (b) b.focus(); } });
    });

    document.addEventListener('click', function (e) {
      if (openOne && !openOne.contains(e.target)) hide(openOne);
    });
  })();

  /* ======================================================================
     Predictive search
     ====================================================================== */
  (function () {
    var form = $('[data-psearch-form]');
    if (!form) return;
    var input = $('[data-psearch-input]', form.parentNode) || $('[data-psearch-input]');
    var panel = $('[data-psearch-panel]');
    if (!input || !panel) return;

    var timer, lastQ = '', ctrl;

    function close() { panel.classList.remove('on'); }
    function open()  { panel.classList.add('on'); }

    function render(items, q) {
      if (!items.length) {
        panel.innerHTML = '<div class="psearch-empty">No matches for &ldquo;' + esc(q) + '&rdquo;</div>';
        open();
        return;
      }
      var html = '<div class="psearch-head">Products</div><div class="psearch-list">';
      items.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        html += '<a class="psearch-i" href="' + p.url + '">' +
          '<span class="psearch-th">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="52" height="60">' : '') + '</span>' +
          '<span class="psearch-body">' +
            '<span class="psearch-t">' + esc(p.title) + '</span>' +
            '<span class="psearch-p">' + moneyFromDollars(p.price) + '</span>' +
          '</span></a>';
      });
      html += '</div><div class="psearch-foot"><a class="psearch-all" href="' + BG.routes.search +
              '?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a></div>';
      panel.innerHTML = html;
      open();
    }

    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }

    function run(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: ctrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          render(items, q);
        })
        .catch(function (e) { if (e.name !== 'AbortError') close(); });
    }

    on(input, 'input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); lastQ = ''; return; }
      if (q === lastQ) { open(); return; }
      lastQ = q;
      timer = setTimeout(function () { run(q); }, 220);
    });
    on(input, 'focus', function () { if (panel.innerHTML.trim() && input.value.trim().length >= 2) open(); });
    on(input, 'keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && e.target !== input) close();
    });
  })();

  /* ======================================================================
     Cart: drawer, add, change, free-shipping meter
     ====================================================================== */
  var Cart = (function () {
    var drawer = $('[data-cart-drawer]');
    var scrim  = $('[data-scrim]');

    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('on');
      if (scrim) scrim.classList.add('on');
      drawer.setAttribute('aria-hidden', 'false');
      lock();
      var x = $('[data-drawer-close]', drawer);
      if (x) x.focus();
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('on')) return;
      drawer.classList.remove('on');
      if (scrim && !$('.filters.on') && !$('[data-mnav].on') && !$('[data-wish-drawer].on')) scrim.classList.remove('on');
      drawer.setAttribute('aria-hidden', 'true');
      unlock();
    }

    function badge(n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n < 1;
      });
    }

    // Same two doors as the server-rendered meter: subtotal over BG.free_over,
    // or BG.free_qty items. The item-count door is an automatic discount in
    // Shopify, so nothing here can read it off the rate - it has to be told.
    function meter(total, count) {
      var free = BG.free_over || 0;
      var freeQty = BG.free_qty || 0;
      var isFree = (free && total >= free) || (freeQty && count >= freeQty);
      $$('[data-ship-meter]').forEach(function (m) {
        var bar = $('[data-ship-bar]', m), msg = $('[data-ship-msg]', m);
        if (!free) { m.hidden = true; return; }
        m.hidden = false;
        var pct = Math.round((total / free) * 100);
        if (freeQty) pct = Math.max(pct, Math.round((count / freeQty) * 100));
        pct = Math.min(100, pct);
        if (bar) bar.style.width = pct + '%';
        m.classList.toggle('done', isFree);
        if (msg) {
          // keep the truck icon the server rendered — repainting without it
          // makes the icon vanish the moment the first item is added
          var ic = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                   'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                   '<path d="M2 6.5h11v10H2z"/><path d="M13 10h4l4 3.5v3h-8z"/>' +
                   '<circle cx="6.5" cy="18.5" r="1.8"/><circle cx="17" cy="18.5" r="1.8"/></svg>';
          var left = freeQty ? Math.max(0, freeQty - count) : 0;
          msg.innerHTML = ic + (isFree
            ? '<span><strong>Free standard shipping unlocked.</strong></span>'
            : '<span>Add <strong>' + money(free - total) + '</strong> more, or <strong>' +
              left + '</strong> more ' + (left === 1 ? 'item' : 'items') +
              ', for free standard shipping.</span>');
        }
      });
    }

    function lineHTML(it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_150x180_crop_center$1$2') : '';
      var v = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="cline" data-line-key="' + it.key + '">' +
        '<a class="cline-th" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" width="74" height="88">' : '') + '</a>' +
        '<div class="cline-b">' +
          '<p class="cline-t"><a href="' + it.url + '">' + it.product_title + '</a></p>' +
          (v ? '<span class="cline-v">' + v + '</span>' : '') +
          '<div class="cline-r">' +
            '<span class="qty" data-qty>' +
              '<button class="qty-b" type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
              '<input class="qty-in" type="number" min="0" value="' + it.quantity + '" data-qty-in data-key="' + it.key + '" aria-label="Quantity">' +
              '<button class="qty-b" type="button" data-qty-up aria-label="Increase">+</button>' +
            '</span>' +
            '<span class="cline-p">' + money(it.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button class="cline-x" type="button" data-line-remove="' + it.key + '" aria-label="Remove">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button></div>';
    }

    function paint(cart) {
      badge(cart.item_count);
      meter(cart.total_price, cart.item_count);
      if (!drawer) return;
      var body = $('[data-cart-body]', drawer);
      var foot = $('[data-cart-foot]', drawer);
      var n    = $('[data-drawer-n]', drawer);
      if (n) { n.textContent = cart.item_count; n.hidden = cart.item_count < 1; }

      if (!cart.item_count) {
        if (body) body.innerHTML =
          '<div class="cempty"><div class="cempty-ic">' +
          '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          '</div><p class="cempty-t">Your bag is empty</p><p class="cempty-s">Nothing here yet — pick a department and start there.</p>' +
          '<a class="btn" href="/collections/all">Start shopping</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      if (body) body.innerHTML = cart.items.map(lineHTML).join('');
      var sub = $('[data-cart-subtotal]', drawer);
      if (sub) sub.textContent = money(cart.total_price);
    }

    function fetchCart() {
      return fetch(BG.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); });
    }

    function addItems(items, btn, msg) {
      if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
      return fetch(BG.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d.description || res.d.message || BG.strings.err, true); return null; }
          return fetchCart();
        })
        .then(function (cart) {
          if (!cart) return;
          paint(cart);
          openDrawer();
          toast(msg || BG.strings.added);
        })
        .catch(function () { toast(BG.strings.err, true); })
        .finally(function () { if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; } });
    }

    function add(id, qty, btn) {
      return addItems([{ id: id, quantity: qty || 1 }], btn);
    }

    function change(key, qty) {
      return fetch(BG.routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          paint(cart);
          if (document.body.classList.contains('tpl-cart')) window.location.reload();
          return cart;
        })
        .catch(function () { toast(BG.strings.err, true); });
    }

    /* delegated events */
    document.addEventListener('click', function (e) {
      var t;

      if ((t = e.target.closest('[data-cart-open]'))) {
        e.preventDefault();
        fetchCart().then(paint).then(openDrawer);
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-scrim]')) {
        closeDrawer();
        MobileNav.close();
        Filters.close();
        Wish.close();
        return;
      }
      if ((t = e.target.closest('[data-add]'))) {
        e.preventDefault();
        var id = t.getAttribute('data-add');
        if (id) add(id, 1, t);
        return;
      }
      if ((t = e.target.closest('[data-line-remove]'))) {
        e.preventDefault();
        change(t.getAttribute('data-line-remove'), 0);
        return;
      }
      if ((t = e.target.closest('[data-qty-up]')) || (t = e.target.closest('[data-qty-down]'))) {
        var wrap = t.closest('[data-qty]');
        var input = $('[data-qty-in]', wrap);
        if (!input) return;
        var dir = t.hasAttribute('data-qty-up') ? 1 : -1;
        var val = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + dir);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-in]');
      if (!input) return;
      var key = input.getAttribute('data-key');
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;
      if (key) change(key, val);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); MobileNav.close(); Filters.close(); Lightbox.close(); Wish.close(); }
    });

    /* product form → ajax add */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form], form.buy-form');
      if (!form) return;
      e.preventDefault();
      var id = $('[name="id"]', form);
      var q  = $('[name="quantity"]', form);
      if (!id) return;
      add(id.value, q ? (parseInt(q.value, 10) || 1) : 1, $('[type="submit"]', form));
    });

    // paint once on load so the meter and badge match the real cart
    if (drawer) fetchCart().then(paint).catch(function () {});

    return { open: openDrawer, close: closeDrawer, add: add, addItems: addItems, refresh: function () { return fetchCart().then(paint); } };
  })();

  /* ======================================================================
     Mobile nav
     ====================================================================== */
  var MobileNav = (function () {
    var el = $('[data-mnav]'), scrim = $('[data-scrim]');
    function open() {
      if (!el) return;
      el.classList.add('on'); if (scrim) scrim.classList.add('on');
      el.setAttribute('aria-hidden', 'false'); lock();
    }
    function close() {
      if (!el || !el.classList.contains('on')) return;
      el.classList.remove('on');
      if (scrim && !$('[data-cart-drawer].on') && !$('.filters.on') && !$('[data-wish-drawer].on')) scrim.classList.remove('on');
      el.setAttribute('aria-hidden', 'true'); unlock();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mnav-open]')) { e.preventDefault(); open(); return; }
      var t = e.target.closest('[data-mnav-toggle]');
      if (t) {
        var sub = t.parentNode.querySelector('[data-mnav-sub]');
        if (!sub) return;
        var isOpen = t.getAttribute('aria-expanded') === 'true';
        t.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        sub.hidden = isOpen;
      }
    });
    return { open: open, close: close };
  })();

  /* ======================================================================
     Collection filters — fetch + swap, keeps the URL shareable
     ====================================================================== */
  var Filters = (function () {
    var panel = $('[data-filters]'), scrim = $('[data-scrim]');

    function open() {
      if (!panel) return;
      panel.classList.add('on'); if (scrim) scrim.classList.add('on'); lock();
    }
    function close() {
      if (!panel || !panel.classList.contains('on')) return;
      panel.classList.remove('on');
      if (scrim && !$('[data-cart-drawer].on') && !$('[data-mnav].on') && !$('[data-wish-drawer].on')) scrim.classList.remove('on');
      unlock();
    }

    var form = $('[data-filter-form]');
    var results = $('[data-results]');
    if (form && results) {
      var busy = false;

      function load(url, push) {
        if (busy) return;
        busy = true;
        results.classList.add('is-loading');
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-results-wrap]');
            var here = document.querySelector('[data-results-wrap]');
            if (next && here) here.innerHTML = next.innerHTML;
            // Swap the whole sidebar, not just the price form: the tag
            // filters live there and their checked state has to follow the
            // results, otherwise a filter reads as unapplied after it applies.
            var ns = doc.querySelector('[data-filters]');
            var hs = document.querySelector('[data-filters]');
            if (ns && hs) hs.innerHTML = ns.innerHTML;
            if (push) history.pushState({ url: url }, '', url);
            var top = document.querySelector('[data-results-top]');
            if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
          })
          .catch(function () { window.location.href = url; })
          .finally(function () { busy = false; results.classList.remove('is-loading'); close(); });
      }

      function submit() {
        var params = new URLSearchParams(new FormData(form));
        // drop empties so the URL stays readable
        var clean = new URLSearchParams();
        params.forEach(function (v, k) { if (v !== '' && v != null) clean.append(k, v); });
        var q = clean.toString();
        load(window.location.pathname + (q ? '?' + q : ''), true);
      }

      on(form, 'change', function (e) {
        if (e.target.matches('input,select')) submit();
      });
      on(form, 'submit', function (e) { e.preventDefault(); submit(); });

      document.addEventListener('click', function (e) {
        var a = e.target.closest('[data-page-link]');
        if (a) { e.preventDefault(); load(a.getAttribute('href'), true); return; }
        var c = e.target.closest('[data-filter-clear]');
        if (c) { e.preventDefault(); load(c.getAttribute('href') || window.location.pathname, true); return; }
        var s = e.target.closest('[data-sort]');
        if (s) return;
      });

      // Delegated: the toolbar holding this select is replaced on every
      // filter swap, so binding straight to the node stops working after the
      // first filter click.
      document.addEventListener('change', function (e) {
        var sel = e.target.closest && e.target.closest('[data-sort-select]');
        if (!sel) return;
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        load(u.pathname + u.search, true);
      });

      window.addEventListener('popstate', function () { load(window.location.href, false); });
    }

    /* collapsible filter groups */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fbox]');
      if (!b) return;
      var body = b.nextElementSibling;
      if (!body) return;
      var isOpen = b.getAttribute('aria-expanded') !== 'false';
      b.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      body.hidden = isOpen;
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filters-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-filters-close]')) { e.preventDefault(); close(); }
    });

    /* grid / list view */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-view]');
      if (!b) return;
      var mode = b.getAttribute('data-view');
      var list = $('[data-results]');
      if (!list) return;
      list.classList.toggle('plist', mode === 'list');
      $$('[data-view]').forEach(function (x) { x.classList.toggle('on', x === b); });
      try { localStorage.setItem('bg_view', mode); } catch (err) {}
    });
    try {
      var saved = localStorage.getItem('bg_view');
      if (saved === 'list') {
        var l = $('[data-results]');
        if (l) l.classList.add('plist');
        $$('[data-view]').forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-view') === 'list'); });
      }
    } catch (err) {}

    return { open: open, close: close };
  })();

  /* ======================================================================
     Hero slider
     ====================================================================== */
  (function () {
    var root = $('[data-hero]');
    if (!root) return;
    var slides = $$('[data-hero-slide]', root);
    var dots   = $$('[data-hero-dot]', root);
    if (slides.length < 2) return;
    var i = 0, timer;
    var delay = parseInt(root.getAttribute('data-hero-delay') || '6000', 10);

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) {
        d.classList.toggle('on', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    function play()  { stop(); if (delay > 0) timer = setInterval(function () { go(i + 1); }, delay); }
    function stop()  { clearInterval(timer); }

    dots.forEach(function (d, k) { on(d, 'click', function () { go(k); play(); }); });
    on($('[data-hero-prev]', root), 'click', function () { go(i - 1); play(); });
    on($('[data-hero-next]', root), 'click', function () { go(i + 1); play(); });
    on(root, 'mouseenter', stop);
    on(root, 'mouseleave', play);

    var sx = null;
    on(root, 'touchstart', function (e) { sx = e.touches[0].clientX; stop(); }, { passive: true });
    on(root, 'touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 46) go(i + (dx < 0 ? 1 : -1));
      sx = null; play();
    });

    go(0); play();
  })();

  /* ======================================================================
     Product gallery + lightbox
     ====================================================================== */
  var Lightbox = (function () {
    var box = $('[data-lightbox]');
    var imgs = [], idx = 0;

    function open(list, n) {
      if (!box) return;
      imgs = list; idx = n;
      paint();
      box.classList.add('on');
      lock();
      // warm the neighbours now, not on page load: these are the 1600px files
      // and pulling all of them up front cost ~1 MB on every product page
      [idx + 1, idx - 1].forEach(function (i) {
        var s = imgs[(i + imgs.length) % imgs.length];
        if (s) { var im = new Image(); im.src = s; }
      });
    }
    function close() {
      if (!box || !box.classList.contains('on')) return;
      box.classList.remove('on'); unlock();
    }
    function paint() {
      var im = $('[data-lightbox-img]', box);
      var c  = $('[data-lightbox-count]', box);
      if (im) im.src = imgs[idx];
      if (c) c.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    function move(d) { if (!imgs.length) return; idx = (idx + d + imgs.length) % imgs.length; paint(); }

    if (box) {
      on($('[data-lightbox-close]', box), 'click', close);
      on($('[data-lightbox-prev]', box), 'click', function () { move(-1); });
      on($('[data-lightbox-next]', box), 'click', function () { move(1); });
      on(box, 'click', function (e) { if (e.target === box) close(); });
      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('on')) return;
        if (e.key === 'ArrowLeft') move(-1);
        if (e.key === 'ArrowRight') move(1);
      });
    }
    return { open: open, close: close };
  })();

  (function () {
    var gal = $('[data-gallery]');
    if (!gal) return;
    var main  = $('[data-gal-img]', gal);
    var count = $('[data-gal-current]', gal);
    var thumbs = $$('[data-gal-th]', gal);
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-full'); });
    if (!srcs.length && main) srcs = [main.getAttribute('src')];
    var at = 0;

    // Warm the candidate the main <img> will actually pick: same srcset and
    // sizes, so the browser resolves identically and the click is a cache hit.
    function warm(t) {
      if (!t || !main) return;
      var i = new Image();
      if (main.sizes) i.sizes = main.sizes;
      var ss = t.getAttribute('data-srcset');
      if (ss) i.srcset = ss;
      i.src = t.getAttribute('data-large');
    }

    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 400); };
    idle(function () { thumbs.forEach(warm); });

    function show(n) {
      at = (n + thumbs.length) % (thumbs.length || 1);
      var t = thumbs[at];
      if (!t || !main) return;

      // The thumbnail state flips immediately so the click always feels
      // answered; the big image is swapped once it can be painted, which
      // avoids a blank frame on the rare uncached hit.
      thumbs.forEach(function (x, k) {
        x.classList.toggle('on', k === at);
        x.setAttribute('aria-selected', k === at ? 'true' : 'false');
      });
      if (count) count.textContent = at + 1;

      var src = t.getAttribute('data-large');
      var ss = t.getAttribute('data-srcset') || '';
      var alt = t.getAttribute('data-alt') || '';
      var mine = ++show.token;

      var apply = function () {
        if (mine !== show.token) return;   // a later click already won
        main.srcset = ss;
        main.src = src;
        main.alt = alt;
      };

      var probe = new Image();
      if (main.sizes) probe.sizes = main.sizes;
      if (ss) probe.srcset = ss;
      probe.src = src;
      if (probe.decode) probe.decode().then(apply).catch(apply);
      else if (probe.complete) apply();
      else { probe.onload = apply; probe.onerror = apply; }

      // keep the neighbours ready for arrow keys and swipes
      warm(thumbs[(at + 1) % thumbs.length]);
      warm(thumbs[(at - 1 + thumbs.length) % thumbs.length]);
    }
    show.token = 0;

    thumbs.forEach(function (t, k) { on(t, 'click', function () { show(k); }); });
    on($('[data-gal-prev]', gal), 'click', function () { show(at - 1); });
    on($('[data-gal-next]', gal), 'click', function () { show(at + 1); });
    on(main, 'click', function () { Lightbox.open(srcs, at); });

    var sx = null;
    on(gal, 'touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    on(gal, 'touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 46) show(at + (dx < 0 ? 1 : -1));
      sx = null;
    });
  })();

  /* ======================================================================
     Tabs (PDP + home rails)
     ====================================================================== */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tab]');
    if (!b) return;
    var scope = b.closest('[data-tabs]');
    if (!scope) return;
    var id = b.getAttribute('data-tab');
    $$('[data-tab]', scope).forEach(function (x) {
      var on_ = x === b;
      x.classList.toggle('on', on_);
      x.setAttribute('aria-selected', on_ ? 'true' : 'false');
    });
    $$('[data-pane]', scope).forEach(function (p) {
      p.hidden = p.getAttribute('data-pane') !== id;
    });
  });

  /* ======================================================================
     Sticky buy bar
     ====================================================================== */
  (function () {
    var bar = $('[data-sticky-buy]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    io.observe(anchor);
  })();

  /* ======================================================================
     Reveal on scroll
     ====================================================================== */
  (function () {
    var items = $$('.rv');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
    items.forEach(function (i) { io.observe(i); });
  })();

  /* ======================================================================
     Back to top
     ====================================================================== */
  (function () {
    var b = $('[data-totop]');
    if (!b) return;
    on(b, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    window.addEventListener('scroll', function () {
      b.classList.toggle('on', window.scrollY > 560);
    }, { passive: true });
  })();

  /* ======================================================================
     Promo bar: dismiss + copy code
     ====================================================================== */
  (function () {
    var bar = $('[data-promo]');
    if (!bar) return;
    try {
      if (localStorage.getItem('bg_promo_off') === bar.getAttribute('data-promo')) bar.hidden = true;
    } catch (e) {}
    on($('[data-promo-x]', bar), 'click', function () {
      bar.hidden = true;
      try { localStorage.setItem('bg_promo_off', bar.getAttribute('data-promo')); } catch (e) {}
    });
    on($('[data-promo-code]', bar), 'click', function () {
      var code = this.getAttribute('data-promo-code');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () { toast('Code ' + code + ' copied'); });
      }
    });
  })();

  /* ======================================================================
     Wishlist — localStorage only, no account, nothing leaves the browser.
     Handles are stored rather than IDs so each row can be rebuilt from
     /products/<handle>.js with a current price and stock state.
     ====================================================================== */
  var Wish = (function () {
    var KEY = 'bg_wish';
    var drawer = $('[data-wish-drawer]');
    var scrim = $('[data-scrim]');

    function read() {
      try {
        var v = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string'; }) : [];
      } catch (e) { return []; }
    }
    function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }

    function sync() {
      var list = read();
      $$('[data-wish]').forEach(function (b) {
        var isOn = list.indexOf(b.getAttribute('data-wish')) > -1;
        b.classList.toggle('on', isOn);
        b.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      });
      $$('[data-wish-count], [data-wish-n]').forEach(function (el) {
        el.textContent = list.length;
        el.hidden = list.length < 1;
      });
    }

    function row(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_150x180_crop_center$1$2');
      var variant = p.variants && p.variants[0];
      var avail = variant && variant.available;
      return '<div class="cline" data-wish-row="' + p.handle + '">' +
        '<a class="cline-th" href="/products/' + p.handle + '">' +
          (img ? '<img src="' + img + '" alt="" width="74" height="88" loading="lazy">' : '') +
        '</a>' +
        '<div class="cline-b">' +
          '<p class="cline-t"><a href="/products/' + p.handle + '">' + p.title + '</a></p>' +
          '<div class="cline-r">' +
            (avail
              ? '<button class="pcard-add" type="button" style="min-height:32px;flex:0 0 auto;padding:0 12px" data-add="' + variant.id + '">Add to bag</button>'
              : '<span class="cline-v">' + BG.strings.sold_out + '</span>') +
            '<span class="cline-p">' + money(p.price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button class="cline-x" type="button" data-wish-remove="' + p.handle + '" aria-label="Remove">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button></div>';
    }

    function emptyHTML() {
      return '<div class="cempty"><div class="cempty-ic">' +
        '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 5.6a5 5 0 00-7.1 0l-.7.7-.7-.7a5 5 0 10-7.1 7.1l.7.7 7.1 7.1 7.1-7.1.7-.7a5 5 0 000-7.1z"/></svg>' +
        '</div><p class="cempty-t">Nothing saved yet</p>' +
        '<p class="cempty-s">Tap the heart on any product to keep it here.</p>' +
        '<a class="btn" href="/collections/all">Browse the catalogue</a></div>';
    }

    function paint() {
      if (!drawer) return;
      var body = $('[data-wish-body]', drawer);
      var foot = $('[data-wish-foot]', drawer);
      var list = read();
      sync();

      if (!list.length) {
        if (foot) foot.hidden = true;
        if (body) body.innerHTML = emptyHTML();
        return;
      }

      if (foot) foot.hidden = false;
      if (body) body.innerHTML = '<p class="cline-v" style="padding:6px 0 10px">Loading your saved items…</p>';

      Promise.all(list.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (items) {
        var live = items.filter(Boolean);
        // A product that has been deleted or unpublished drops out of the
        // stored list rather than rendering as a broken row.
        var handles = live.map(function (p) { return p.handle; });
        if (handles.length !== list.length) write(handles);
        if (!live.length) {
          if (foot) foot.hidden = true;
          if (body) body.innerHTML = emptyHTML();
          sync();
          return;
        }
        if (body) body.innerHTML = live.map(row).join('');
        sync();
      });
    }

    function open() {
      if (!drawer) return;
      paint();
      drawer.classList.add('on');
      if (scrim) scrim.classList.add('on');
      drawer.setAttribute('aria-hidden', 'false');
      lock();
      var x = $('[data-drawer-close]', drawer);
      if (x) x.focus();
    }
    function close() {
      if (!drawer || !drawer.classList.contains('on')) return;
      drawer.classList.remove('on');
      if (scrim && !$('[data-cart-drawer].on') && !$('[data-mnav].on') && !$('.filters.on')) scrim.classList.remove('on');
      drawer.setAttribute('aria-hidden', 'true');
      unlock();
    }

    document.addEventListener('click', function (e) {
      var t;
      if (e.target.closest('[data-wish-open]')) { e.preventDefault(); open(); return; }
      if ((t = e.target.closest('[data-wish-remove]'))) {
        e.preventDefault();
        var h = t.getAttribute('data-wish-remove');
        write(read().filter(function (x) { return x !== h; }));
        paint();
        toast('Removed from saved items');
        return;
      }
      if (e.target.closest('[data-wish-clear]')) {
        e.preventDefault();
        write([]); paint(); toast('Saved items cleared');
        return;
      }
      if ((t = e.target.closest('[data-wish]'))) {
        e.preventDefault();
        var handle = t.getAttribute('data-wish');
        var list = read(), at = list.indexOf(handle);
        if (at > -1) { list.splice(at, 1); toast('Removed from saved items'); }
        else { list.push(handle); toast('Saved for later'); }
        write(list);
        sync();
        if (drawer && drawer.classList.contains('on')) paint();
      }
    });

    sync();
    return { open: open, close: close };
  })();

  /* ======================================================================
     "Buy it as a set" — same-type combo on the product page.
     Ticking a row changes the total and the button label; the whole set goes
     into the bag as one /cart/add request rather than three round trips.
     ====================================================================== */
  (function () {
    var root = $('[data-combo]');
    if (!root) return;
    var boxes = $$('[data-combo-cb]', root);
    var btn = $('[data-combo-add]', root);
    var picked = [];

    function refresh() {
      var total = 0, n = 0;
      picked = [];
      boxes.forEach(function (cb) {
        var row = cb.closest('[data-combo-i]');
        var mark = row ? $('.combo-box', row) : null;
        if (cb.checked) {
          total += parseInt(cb.getAttribute('data-price'), 10) || 0;
          n++;
          picked.push({ id: cb.getAttribute('data-variant'), quantity: 1 });
          if (mark) mark.classList.add('on');
          if (row) row.classList.remove('off');
        } else {
          if (mark) mark.classList.remove('on');
          if (row) row.classList.add('off');
        }
      });

      $$('[data-combo-n]', root).forEach(function (el) { el.textContent = n; });
      var t = $('[data-combo-total]', root);
      if (t) t.textContent = money(total);

      var note = $('[data-combo-note]', root);
      var free = BG.free_over || 0;
      var freeQty = BG.free_qty || 0;
      if (note && free) {
        // Ticking the third row is itself enough to earn free standard
        // shipping, so the note has to watch n as well as the total.
        note.textContent = ((free && total >= free) || (freeQty && n >= freeQty))
          ? 'This set ships free on standard.'
          : money(free - total) + ' under the ' + (freeQty ? freeQty + '-item / ' : '') + 'free-shipping line.';
      }
      if (btn) btn.disabled = n < 1;
    }

    boxes.forEach(function (cb) { on(cb, 'change', refresh); });
    refresh();

    on(btn, 'click', function () {
      if (!picked.length) return;
      Cart.addItems(picked.slice(), btn,
        picked.length > 1 ? (picked.length + ' items added to your bag') : null);
    });
  })();

  /* ======================================================================
     Newsletter (Shopify customer form) — inline confirmation
     ====================================================================== */
  (function () {
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      var ok = $('[data-news-ok]');
      if (ok) ok.hidden = false;
    }
  })();

})();
